// extracted by mini-css-extract-plugin
export default {"wrapper":"AgeAndGenderComponent_wrapper__r4bnY","wrapper_btn":"AgeAndGenderComponent_wrapper_btn__ZZC8r","error_message":"AgeAndGenderComponent_error_message__ZvAoE"};